import { render, staticRenderFns } from "./PasswordRecoveryVerify.vue?vue&type=template&id=07a5c3cf&"
import script from "./PasswordRecoveryVerify.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoveryVerify.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecoveryVerify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports